<div data-cy="project-share__page">
  <div mat-dialog-title>
    <div class="header-row">
      <div>
        <i data-cy="project-share__on-close-2" class="uil uil-angle-left-b unicon-icon d-cursor-hand" style="color: #2800D2" (click)="onClose(true)"></i>
        <span class="title">{{data.name+' '}} {{ 'shared_projects.connect_req' | transloco | capitaliz }}</span>
      </div>
      <mat-icon data-cy="project-share__on-close" class="icon-click" (click)="onClose(false)">close</mat-icon>
    </div>
  </div>

  <!-- <mat-dialog-content> -->
    <div *ngIf="isLoading()">
        <mat-progress-bar mode="buffer"></mat-progress-bar>
    </div>
    <mat-dialog-content data-cy="project-share__dialog-content" class="p-none">
      <div class="col-xs-12" *ngIf="!isLoading()">
      <div *ngIf="isTargetSide" class="alert-warning-custom">
        <mat-icon class="warn-icon">info</mat-icon>
        <span>{{'projects.project_share'| transloco}} <strong>{{sourceName}}</strong></span>
      </div>
        <h3 class="subtitle full-width"><strong>{{'shared_projects.send_conn_req' | transloco}}</strong></h3>
        <mat-divider class="full-width"></mat-divider>
        <div class="full-width">
          <mat-radio-group [(ngModel)]="entity.shared_level"
            (ngModelChange)="updateEntity()"
            [disabled]="isTargetSide"
            class="options-group">

            <ng-container *ngFor="let option of options; let i = index">
              <div class="radio-option">

                <!-- Radio Button Label -->
                <mat-radio-button [value]="option.type" [disabled]="isTargetSide">
                  <div *ngIf="!option.description" class="option-label">
                    {{ option.label | transloco}}
                  </div>
                  <div *ngIf="option.description" class="option-description">
                    {{ option.label | transloco}}
                  </div>
                </mat-radio-button>

                <!-- Nested content for Chat -->
                <div class="nested-content col-xs-8" 
                    *ngIf="entity.shared_level === 'chat' && option.type === 'chat'">
                  <app-generic-multiselect-checkbox data-cy="project-share__generic-multiselect-checkbox" class="full-width"
                                                    [placeholder]="'users.add_users' | transloco"
                                                    name="users"
                                                    [(ngModel)]="entity.users"
                                                    [disabled]="isTargetSide"
                                                    [readOnly]="isTargetSide"
                                                    [uniqueId]="'add-users'">
                    <app-generic-multiselect-checkbox-option
                      *ngFor="let user of users"
                      [value]="user">
                      {{ user.name }}
                    </app-generic-multiselect-checkbox-option>
                  </app-generic-multiselect-checkbox>
                </div>

                <!-- Nested content for Read -->
                <div class="nested-content col-xs-12 align-btm"
                    *ngIf="entity.shared_level === 'read' && option.type === 'read'">
                  <div class="col-xs-6">
                    <app-generic-multiselect-checkbox data-cy="project-share__generic-multiselect-checkbox-2" class="full-width"
                                                      [placeholder]="'shared_projects.shareable_info'| transloco"
                                                      name="sharables"
                                                      [(ngModel)]="entity.modules"
                                                      [disabled]="isTargetSide"
                                                      [readOnly]="isTargetSide"
                                                      [maxChipItems]="4" required>
                      <app-generic-multiselect-checkbox-option
                        *ngFor="let module of modules"
                        [value]="module">
                        {{ 'reusable.project_setting.'+module.module_id | transloco }}
                      </app-generic-multiselect-checkbox-option>
                    </app-generic-multiselect-checkbox>
                  </div>

                  <div class="col-xs-6">
                    <app-generic-multiselect-checkbox data-cy="project-share__generic-multiselect-checkbox-3" class="full-width"
                                                      [placeholder]="'users.add_users' | transloco"
                                                      name="users"
                                                      [(ngModel)]="entity.users"
                                                      [disabled]="isTargetSide"
                                                      [readOnly]="isTargetSide"
                                                      [uniqueId]="'add-users'">
                      <app-generic-multiselect-checkbox-option
                        *ngFor="let user of users"
                        [value]="user">
                        {{ user.name }}
                      </app-generic-multiselect-checkbox-option>
                    </app-generic-multiselect-checkbox>
                  </div>
                </div>
              </div>

              <!-- Divider between options, not after last one -->
              <!-- <mat-divider *ngIf="i < options.length - 1"></mat-divider> -->
            </ng-container>
          </mat-radio-group>
        </div>
      </div>
    </mat-dialog-content>
  
  <!-- </mat-dialog-content> -->

  <mat-dialog-actions data-cy="project-share__dialog-actions" align="end" class="full-width">
    <button data-cy="project-share__submit-btn" mat-flat-button color="primary" (click)="submit()" [disabled]="isSubmitting() || !entity.shared_level || (entity.shared_level==='read' && !entity.modules.length) || isTargetSide">
      <span class="flex-disp">
        <mat-spinner *ngIf="isSubmitting()" class="white-spinner" [diameter]="14"></mat-spinner>
        <span>{{ 'shared_projects.send' | transloco | capitaliz }}</span>
      </span>
    </button>
  </mat-dialog-actions>
</div>